import { render, staticRenderFns } from "./OIAReport.vue?vue&type=template&id=b22ffc20&scoped=true"
import script from "./OIAReport.vue?vue&type=script&lang=js"
export * from "./OIAReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22ffc20",
  null
  
)

export default component.exports